import { DrilldownSlice } from "@sportal/api/reports";
import {
  DrilldownDataKeys,
  ReportsPeriod,
} from "../../../../helpers/reports.helper.types";
import { LoadingState } from "../../../shared/withLoadableSlice.types";

export const LOAD_TABLE = "[REPORTS] LOAD_TABLE";
export const LOAD_TABLE_SUCCESS = "[REPORTS] LOAD_TABLE_SUCCESS";
export const LOAD_TABLE_FAILURE = "[REPORTS] LOAD_TABLE_FAILURE";

interface LoadTableAction {
  type: typeof LOAD_TABLE;
  payload: {
    id: DrilldownDataKeys;
    period: ReportsPeriod;
    profile: string;
  };
}

interface LoadTableSuccessAction {
  type: typeof LOAD_TABLE_SUCCESS;
  payload: {
    id: DrilldownDataKeys;
    data: DrilldownSlice[];
    period: ReportsPeriod;
    profile: string;
  };
}

interface LoadTableFailureAction {
  type: typeof LOAD_TABLE_FAILURE;
  payload: {
    id: DrilldownDataKeys;
    period: ReportsPeriod;
    profile: string;
    error: any;
  };
}

export type TableActionTypes =
  | LoadTableAction
  | LoadTableSuccessAction
  | LoadTableFailureAction;

export interface TableState extends LoadingState {
  data: DrilldownSlice[];
  period: ReportsPeriod;
  profile: string;
}
